import { cn } from '@helpers/cn';
import { useRef, type ChangeEvent } from 'react';

import { TProps } from './types/TProps';

export const FilePicker = ({ accept, onFile, children, className }: TProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const openPicker = () => {
    inputRef.current?.click();
  };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    event.target.value = '';

    if (file) {
      onFile(file);
    }
  };

  return (
    <span className={cn('contents', className)} onClick={openPicker}>
      {children}
      <input
        ref={inputRef}
        className="hidden"
        type="file"
        accept={accept}
        onClick={(event) => event.stopPropagation()}
        onChange={onChange}
      />
    </span>
  );
};
